import { useCallback, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ReactSelectDropdown from "react-dropdown-select";
import { GetListCommonCall, PostCommonAPI, PutCommonAPI } from "../../POS/APIServices/POS_API_Services";
import HelperService from "../../Services/HelperService";
type props = {
    onSubmit: (data: any) => void;
    onClose: () => void;
    show: boolean;
    isEdit: boolean;
    editData?: any;
}
const CommonModalGroupMembers = ({ show, onSubmit, onClose, isEdit, editData }: props) => {
    const [groupName, setGroupName] = useState('');
    const [description, setDescription] = useState('');
    const [membersList, setMembersList] = useState<any[]>([]);
    const [selectedMembers, setSelectedMembers] = useState<any[]>([]);
    const [errors, setErrors] = useState<boolean>(false);

    const getMembersList = useCallback(() => {
        GetListCommonCall('groups/customers/for-dropdown', {}, '').then((response: any) => {
            if (response && response.list.length > 0) {
                setMembersList(response.list || [])
            }
        }).catch((error: any) => {

        })
    }, []);

    useEffect(() => {
        if (show) {
            setErrors(false);
            setGroupName('');
            setDescription('');
            setSelectedMembers([]);
            getMembersList();
            if (isEdit && editData) {
                setGroupName(editData.title);
                setDescription(editData.description);
                setSelectedMembers(editData.members || []);
            } else {
                setGroupName('');
                setDescription('');
                setSelectedMembers([]);
            }
        }
    }, [show, isEdit, editData, getMembersList]);
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        let flag = false;
        setErrors(false);
        if (!groupName) {
            flag = true;
        }
        if (!description) {
            flag = true;
        }
        if (selectedMembers.length === 0) {
            flag = true;
        }
        if (flag) {
            setErrors(true);
            return;
        }
        let body = {
            title: groupName,
            description: description,
            members: selectedMembers.map((item: any) => item.id)
        }
        if (isEdit) {
            PutCommonAPI(body, `groups/${editData.id}`, 'savebtn').then((res: any) => {
                if (res.status) {
                    onSubmit(true);
                }
            })
        } else {
            PostCommonAPI(body, 'groups', 'savebtn').then((res: any) => {
                if (res.status) {
                    onSubmit(true);
                }
            })
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{isEdit ? 'Edit Group' : 'Create Group'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form >
                    <Form.Group className="mb-3">
                        <Form.Label>Group Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={groupName}
                            maxLength={200}
                            onChange={(e) => setGroupName(e.target.value)}
                            onKeyDown={HelperService.allowOnlyAlphaNumericValues}
                            placeholder="Enter group name"
                        />
                        {errors && !groupName && <Form.Text className="text-danger font-12">Please enter group name</Form.Text>}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as='textarea'
                            rows={3}
                            className='h-auto'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter description"
                        />

                        {errors && !description && <Form.Text className="text-danger font-12">Please enter description</Form.Text>}
                    </Form.Group>

                    <Form.Group className="mb-3 group-div">
                        <Form.Label>Select Members</Form.Label>
                        <ReactSelectDropdown
                            options={membersList}
                            values={selectedMembers}
                            multi={true}
                            labelField="name"
                            selectAll={true}
                            searchable={true}
                            searchBy="name"
                            clearable={selectedMembers.length > 0 ? true : false}
                            closeOnSelect={false}
                            sortBy="name"
                            valueField="id"
                            className="group-dropdown"
                            onChange={(values) => {
                                if (values.length > 0) {
                                    setSelectedMembers(values);
                                }
                            }}
                            placeholder={'Select members'}

                        />
                        {errors && selectedMembers.length === 0 && <Form.Text className="text-danger font-12">Please select members</Form.Text>}
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" id='savebtn' type="button" onClick={handleSubmit} className="btn btn-primary w-100">
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default CommonModalGroupMembers;